import { useShallow } from 'zustand/shallow';
import { useGcsStore } from '../../../store/useGcsStore';
import { SingleForeignAircraftMarker } from './SingleForeignAircraftMarker';

interface GcsForeignAircraftsProps {
  gcsId: string;
}

export const GcsForeignAircrafts = ({ gcsId }: GcsForeignAircraftsProps) => {
  const aircraftIds = useGcsStore(
    // useShallow ensures the component only re-renders if the actual keys inside the array change.
    useShallow((state) => {
      const gcsData = state.data.get(gcsId);
      if (!gcsData?.foreignAircraftDetailsMap) return [];
      return Array.from(gcsData.foreignAircraftDetailsMap.keys());
    })
  );

  return (
    <>
      {aircraftIds.map((aircraftId) => (
        <SingleForeignAircraftMarker
          key={`foreign-aircraft-${gcsId}-${aircraftId}`}
          gcsId={gcsId}
          aircraftId={aircraftId}
        />
      ))}
    </>
  );
};
